import { AuthData, User } from '../index';

export class SetUserFromUserState {
  static readonly type = '[UserState] Set User';
  constructor(public user: Partial<User>) {}
}

export class SetAuthDataFromUserState {
  static readonly type = '[UserState] Set Auth Data';
  constructor(public authData: Partial<AuthData>) {}
}

export class ResetUserState {
  static readonly type = '[UserState] Reset';
}

